<div class="grid grid-cols-1  md:grid-cols-[1fr_3fr]">
    <section
        class="w-full rounded-b-[2rem] px-8 py-10 sm:px-12 sm:py-14 text-white shadow-sm overflow-hidden md:col-span-2"
        style="background: linear-gradient(90deg, #612737 0%, #a4536d 50%, #c46d87 100%);">
        <div class="max-w-7xl mx-auto flex flex-col justify-center gap-3">
            <nav
                class="flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-wider uppercase text-white/80">
                <a routerLink="/" class="hover:text-white transition-colors">INICIO</a>
                <span>/</span>
                <a routerLink="/catalogo" class="hover:text-white transition-colors">CATÁLOGO</a>
                <span>/</span>
                <span class="text-white/60 font-normal">{{ breadcrumb() }}</span>
            </nav>

            <h1
                class="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-wide uppercase text-white drop-shadow-sm">
                {{ titulo() }}
            </h1>
        </div>
    </section>
    <div class="block pt-4 px-4 w-full md:hidden">
        <button (click)="onOpenDrawerFiltro()"
            class="w-full flex items-center justify-center gap-2 bg-white text-gray-800 font-bold text-sm border border-gray-200 rounded-2xl py-3 px-4 shadow-sm hover:bg-gray-50 active:scale-[0.98] transition-all cursor-pointer">
            <svg class="w-5 h-5 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            <span>Filtrar productos</span>
        </button>
    </div>

    <div class=" hidden md:block m-4 rounded-lg">
        <app-catalog-sidebar [minPrice]="minPrice()" [maxPrice]="maxPrice()" [categories]="(misCategorias())"
            [bestSellers]="misMasVendidos()" (filterApply)="onFiltrarPrecios($event)"></app-catalog-sidebar>
    </div>

    <div class="m-4 rounded-3xl border border-gray-100 shadow-sm">
        <app-ui-loading *ngIf="loading()"></app-ui-loading>
        <app-product-grid-section *ngIf="!loading()" [products]="productos()" [total]="total()"
            (sortChange)="onSortChange($event)" (pageSizeChange)="onPageSizeChange($event)"></app-product-grid-section>
    </div>

</div>

<ng-template #drawerFiltro>
    <app-catalog-sidebar [minPrice]="minPrice()" [maxPrice]="maxPrice()" [categories]="(misCategorias())"
        [bestSellers]="misMasVendidos()" (filterApply)="onFiltrarPrecios($event)"></app-catalog-sidebar>
</ng-template>